import React from 'react';
import { RobaZaKupca, RobaZaKupcaStanje } from '../types';

interface Props {
  roba: RobaZaKupca[];
  /** „Kupac preuzeo" — roditelj pita za potvrdu i šalje. */
  onPreuzeo: (red: RobaZaKupca) => void;
  /** Otpremnica za koju zahtev upravo ide — da se dugme ne pritisne dvaput. */
  zauzeto?: string | null;
  /** Šta je server rekao posle klika, po otpremnici. */
  ishod?: Record<string, string>;
}

const OZNAKA: Record<RobaZaKupcaStanje, string> = {
  CekaPrevoz: 'čeka prevoz',
  NaTuri: 'na turi',
  Stiglo: 'stiglo',
  Preuzeto: 'preuzeto'
};

/**
 * Roba za kupce koja ide u ovaj objekat — kupac dolazi sam (9999001/9999002) ili
 * ga vozi prodavnica (9999013), a roba je bila drugde. Od 21.10.2026. je vozi
 * logistika (odluka vlasnika 19.10.2026): ovde se vidi dokle je stigla, a kad
 * stigne — poslovođa javlja kupcu i, kad ga kupac odnese, klikne „Kupac preuzeo".
 * Otpremnica se tada sama kukiči u ERP-u.
 */
export default function RobaZaKupce({ roba, onPreuzeo, zauzeto = null, ishod = {} }: Props) {
  if (roba.length === 0) {
    return <p className="empty">Nema robe za kupce koja ide u ovaj objekat.</p>;
  }

  return (
    <ul className="storelist">
      {roba.map((red) => (
        <li key={red.documentKey}>
          <span className="storelist__where">
            {red.kupac || '(bez imena)'}
            {red.telefon && <> · {red.telefon}</>}
            <span className="muted"> · {red.documentKey}</span>
          </span>

          <span className={red.stanje === 'Stiglo' ? 'flag flag--ok' : 'flag'}>{OZNAKA[red.stanje]}</span>

          <span className="storelist__why">{red.opis}</span>

          <span className="storelist__why muted">
            {red.stavke
              .map((s) => `${s.naziv} × ${s.kolicina}${s.putuje ? '' : ' (već u objektu)'}`)
              .join(', ')}
          </span>

          {red.mozePreuzeo && (
            <button
              type="button"
              className="primary"
              disabled={zauzeto === red.documentKey}
              onClick={() => onPreuzeo(red)}
            >
              Kupac preuzeo
            </button>
          )}

          {ishod[red.documentKey] && <p className="sourcing__reserved">{ishod[red.documentKey]}</p>}
        </li>
      ))}
    </ul>
  );
}
